// The app's name, in one place. Registered as the `brand` API so that every
// plugin reads it and nobody hardcodes the name: changing it is one edit here.
// It also carries the About text, which the landing page's footer and the
// settings screen's About section both show.
export interface Credit {
  /** The project's name, e.g. "Stockfish". */
  name: string;
  /** What the app uses it for, e.g. "the chess engine". */
  role: string;
  /** Its licence as an SPDX id, or a short phrase for a service. */
  licence: string;
  url: string;
}

export interface About {
  /** One or two sentences: what the app is and where it runs. */
  summary: string;
  credits: Credit[];
}

export interface Brand {
  /** The product name, as shown in the title, the landing page and the status bar. */
  name: string;
  /** One sentence under the name on the landing page. */
  tagline: string;
  about: About;
}

/**
 * The `<meta name="description">` of `index.html`, which crawlers read from
 * the static file: this constant and the literal there must stay the same
 * (the About summary's first sentence, under 160 characters).
 */
export const META_DESCRIPTION =
  'Continual Chess reads your chess.com games with a chess engine and shows where they were won and lost.';

export const brand: Brand = {
  name: 'Continual Chess',
  tagline: 'See where your games are won and lost.',
  about: {
    summary:
      'Continual Chess reads your chess.com games with a chess engine and shows where they were won and lost. It runs entirely in your browser: your games, their analysis and your settings stay on this device.',
    credits: [
      { name: 'Stockfish', role: 'the chess engine', licence: 'GPL-3.0', url: 'https://stockfishchess.org' },
      { name: 'Chessground', role: 'the board, by Lichess', licence: 'GPL-3.0-or-later', url: 'https://github.com/lichess-org/chessground' },
      { name: 'chess.js', role: 'the rules of the game', licence: 'BSD-2-Clause', url: 'https://github.com/jhlywa/chess.js' },
      { name: 'Lichess chess-openings', role: 'opening names', licence: 'CC0-1.0', url: 'https://github.com/lichess-org/chess-openings' },
      { name: 'chess.com Published-Data API', role: 'your games', licence: 'public API', url: 'https://www.chess.com/news/view/published-data-api' },
    ],
  },
};
